<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">
        <transition name="fade">
          <b-icon class="is-pulled-right" pack="fas" icon="check-circle" size="is-medium" type="is-success" v-if="timeEntry && timeEntry.start"/>
        </transition>
        {{ hrInfo.hr.label }}
      </p>
    </header>
    <section class="modal-card-body has-text-centered" v-if="timeEntry && timeEntry.start">

      <div class="is-size-3" v-if="!timeEntry.end">
        {{ $t('message.time.start') }}: {{ formattedTimeEntryStart }}
      </div>
      <div class="is-size-3" v-if="timeEntry.end">
        {{ $t('message.time.end') }}: {{ formattedTimeEntryEnd }}
      </div>
      <div class="is-size-4 has-text-weight-bold" v-if="timeEntry.end">
        {{ $t('message.time.worked') }}: {{ workedTime }}
      </div>
      <div v-if="timeEntry.activity">
        {{ timeEntry.activity.label }}
      </div>

    </section>
    <section class="modal-card-body has-text-centered" v-if="activities" v-show="!form.loading">
      <div class="field is-horizontal">
        <div class="field-label is-normal">
          <label class="label" for="activity">{{ $t('message.time.activity') }}:</label>
        </div>
        <div class="field-body" style="width: 100%">
          <div class="field">
            <b-select id="activity" v-model="form.activity" :disabled="form.loading" expanded>
              <option v-for="activity in activities" :value="activity" :key="activity.id" >{{activity.label}}</option>
            </b-select>
          </div>
        </div>
      </div>
      <b-button @click="multiActivityPunch" :disabled="!form.activity || form.loading">{{ $t('message.punch') }}</b-button>
    </section>
    <footer class="modal-card-foot">
      &nbsp;
    </footer>
  </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import toaster from './toaster'

const restTimeFormat = 'YYYY-MM-DDTHH:mm:ssZ'

export default {
  props: ['datetimeMoment', 'code', 'pin', 'hrInfo'],
  data() {
    return {
      punchInfo: null,
      timeEntry: null,
      activity: null,
      activities: null,
      form: {
        activity: null,
        loading: false,
      }
    }
  },
  computed: {
    formattedTimeEntryStart() {
      return this.timeEntry && this.timeEntry.start ? moment(this.timeEntry.start, restTimeFormat).format('HH:mm') : ''
    },
    formattedTimeEntryEnd() {
      return this.timeEntry && this.timeEntry.end ? moment(this.timeEntry.end, restTimeFormat).format('HH:mm') : ''
    },
    workedTime() {
      if (!this.timeEntry || !this.timeEntry.start || !this.timeEntry.end) {
        return ''
      }

      return moment.utc(moment(this.timeEntry.end, restTimeFormat).diff(moment(this.timeEntry.start))).format("HH:mm")
    },
  },
  mounted() {
    axios.post('/api/v1/hr/punch/info', {code: this.code, pin: this.pin})
        .then(res => this.punchInfo = res.data)
        .then(this.punch)
        .catch(toaster.catch(this))
  },
  methods: {
    punch() {
      this.form.loading = true

      if (this.punchInfo && this.punchInfo.lastTimeEntry && !this.punchInfo.lastTimeEntry.end) {
        // on punch out autoClose
        const punchOut = {
          code: this.code,
          pin: this.pin,
          timeEntryId: this.punchInfo.lastTimeEntry.id,
          timeEntryStart: this.punchInfo.lastTimeEntry.start,
          dateTime: this.datetimeMoment.format(restTimeFormat)
        }
        axios.post('/api/v1/hr/punch/out', punchOut)
            .then(res => this.timeEntry = res.data)
            .catch(toaster.catch(this))
            .finally(this.autoClose)
      } else {
        if (this.punchInfo.activities.length > 1) {
          // on punch in !autoClose
          this.activities = this.punchInfo.activities
          this.form.loading = false
        } else {
          // on punch in autoClose
          const punchIn = {
            code: this.code,
            pin: this.pin,
            activityId: this.punchInfo.activities[0].id,
            dateTime: this.datetimeMoment.format(restTimeFormat)
          }
          axios.post('/api/v1/hr/punch/in', punchIn)
              .then(res => this.timeEntry = res.data)
              .catch(toaster.catch(this))
              .finally(this.autoClose)
        }
      }
    },
    multiActivityPunch() {
      this.form.loading = true
      const punchIn = {
        code: this.code,
        pin: this.pin,
        activityId: this.form.activity.id,
        dateTime: this.datetimeMoment.format(restTimeFormat)
      }
      console.log(punchIn)
      axios.post('/api/v1/hr/punch/in', punchIn)
          .then(res => this.timeEntry = res.data)
          .catch(toaster.catch(this))
          .finally(this.autoClose)
    },
    autoClose() {
      setTimeout(this.close, 2000)
    },
    close() {
      this.$emit('close')
      this.form.loading = false
    }
  }
}
</script>
